import type { ReactNode } from 'react';
import { Card, Text, Spinner, makeStyles, tokens } from '@fluentui/react-components';

interface ChartCardProps {
  title: string;
  subtitle?: string;
  isLoading?: boolean;
  loadingLabel?: string;
  isEmpty?: boolean;
  emptyMessage?: string;
  children: ReactNode;
}

const useStyles = makeStyles({
  card: {
    padding: '18px 20px',
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
  },
  header: { display: 'flex', flexDirection: 'column', gap: '2px' },
  title: { fontWeight: tokens.fontWeightSemibold, fontSize: tokens.fontSizeBase400 },
  subtitle: { color: tokens.colorNeutralForeground3, fontSize: tokens.fontSizeBase200 },
  body: { display: 'flex', flexDirection: 'column' },
  centered: { display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px 0' },
});

/** Card genérica para envolver un gráfico — título/subtítulo, estado de carga y estado vacío. */
export function ChartCard({ title, subtitle, isLoading, loadingLabel, isEmpty, emptyMessage, children }: ChartCardProps) {
  const s = useStyles();
  return (
    <Card className={s.card}>
      <div className={s.header}>
        <span className={s.title}>{title}</span>
        {subtitle && <span className={s.subtitle}>{subtitle}</span>}
      </div>
      {isLoading ? (
        <div className={s.centered}><Spinner size="small" label={loadingLabel} /></div>
      ) : isEmpty ? (
        <div className={s.centered}><Text size={200}>{emptyMessage}</Text></div>
      ) : (
        <div className={s.body}>{children}</div>
      )}
    </Card>
  );
}
